<div class="ndf-card-summary">
  <div class="ndf-card-summary__header">
    <div class="ndf-card-summary__header__actions">
      <div class="ndf-card-summary__header__left">
        <a
          class="ndf-card-summary__header__id"
          [routerLink]="['/dashboard/control/derivative-management/derivatives/list']"
          [queryParams]="{ demandId: ndfDemand?.id }">
          #{{ ndfDemand?.sequentialId }}
        </a>

        <!-- Link para Comex Operation se existir -->
        <a
          *ngIf="ndfDemand?.comexOperation?.sequentialId"
          class="ndf-card-summary__header__id"
          [routerLink]="['/dashboard/comex-operation/v1/details', ndfDemand?.comexOperation?.id]">
          #{{ ndfDemand?.comexOperation?.sequentialId }}
        </a>

        <!-- Link para Loan Operation se existir -->
        <a
          *ngIf="ndfDemand?.loanOperation?.sequentialId"
          class="ndf-card-summary__header__id"
          [routerLink]="[
            '/dashboard/costs/debt/management/launch-installments',
            ndfDemand?.loanOperation?.id,
          ]">
          #{{ ndfDemand?.loanOperation?.sequentialId }}
        </a>

        <span class="ndf-card-summary__header__reference">
          {{ getFormattedReference() }}
        </span>

        <span
          style="margin-left: 1rem; width: 100%; color: red"
          *ngIf="
            ndfDemand?.operation !== 'Indicative' &&
            !ndfDemand?.loanOperation &&
            !ndfDemand?.comexOperation
          ">
          {{ tk.General.DemandLinkComexLoan | t }}
        </span>
      </div>
      <div class="ndf-card-summary__header__action">
        <app-action-menu
          [items]="actionIcons"
          (sendItemClick)="handleAction($event)"></app-action-menu>
        <i
          class="pi"
          [ngClass]="{
            'pi-chevron-circle-down': !isCollapsed,
            'pi-chevron-circle-up': isCollapsed,
          }"
          (click)="toggleCollapse()">
        </i>
      </div>
    </div>
    <div class="ndf-card-summary__header__content">
      <div class="ndf-card-summary__header__content__item max-w-200px">
        <p>{{ ndfDemand?.company }}</p>
      </div>
      <div class="ndf-card-summary__header__content__item">
        <h3>{{ tk.Management.BudgetRate1 | t }}</h3>
        <p>{{ (ndfDemand?.budgetRate | number: '1.4-4') || 0 }}</p>
      </div>
      <div class="ndf-card-summary__header__content__item">
        <h3>{{ tk.Management.NdfValue | t }} ME</h3>
        <p>{{ ndfDemand?.currency }} {{ ndfDemand?.transactionValue | number: '1.2-2' }}</p>
      </div>
      <div class="ndf-card-summary__header__content__item">
        <h3>{{ tk.Management.NdfDueDate | t }}</h3>
        <p>{{ ndfDemand?.dueDate || '' | vaultDate }}</p>
      </div>
      <div class="ndf-card-summary__header__content__item">
        <h3>{{ tk.Management.NdfOperationType | t }}</h3>
        <p>{{ getOperationTypeLabel(ndfDemand?.operation || '') }}</p>
      </div>
      <div class="ndf-card-summary__header__content__item">
        <h3>{{ tk.Management.NdfOperations | t }}</h3>
        <p>
          <span
            style="cursor: help"
            pTooltip="Total de operações contratadas em aberto"
            tooltipPosition="top"
            >{{ ndfDemand?.totalOperationsHiredAndOpen || 0 }}</span
          >
          /
          <span
            style="cursor: help"
            pTooltip="Total de operações contratadas"
            tooltipPosition="top"
            >{{ ndfDemand?.totalOperationsHired || 0 }}</span
          >
          /
          <span
            style="cursor: help; color: #3b82f6; font-weight: 600"
            pTooltip="Total de operações"
            tooltipPosition="top"
            >{{ ndfDemand?.totalOperations || 0 }}</span
          >
        </p>
      </div>

      <div class="ndf-card-summary__header__content__item">
        <h3>{{ tk.General.RegistrationDate | t }}</h3>
        <p>{{ ndfDemand?.createdAt || '' | vaultDate }}</p>
      </div>
      <div class="ndf-card-summary__header__content__item">
        <h3>{{ tk.Management.user | t }}</h3>
        <p>{{ ndfDemand?.userName }}</p>
      </div>
    </div>
    <div
      *ngIf="isCollapsed && innerOperations?.length"
      class="ndf-card-summary__header__content ndf-card-summary__header__content--collapsed">
      <app-table
        class="w-100"
        [items]="innerOperations"
        [deleteTitle]="tk.User.UserTitleDeleteConfirmation | t"
        [headers]="headers"
        [columns]="columns"
        [hasCheckbox]="false"
        [hasPagination]="false"
        (sendTableAction)="handleTableAction($event)"
        (sendTableSelection)="handleTableSelection($event)">
      </app-table>
    </div>
  </div>
</div>
